import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=1aef1c6c&"
import script from "./ProfilePage.vue?vue&type=script&lang=ts&"
export * from "./ProfilePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aef1c6c')) {
      api.createRecord('1aef1c6c', component.options)
    } else {
      api.reload('1aef1c6c', component.options)
    }
    module.hot.accept("./ProfilePage.vue?vue&type=template&id=1aef1c6c&", function () {
      api.rerender('1aef1c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Applicant/Details/ProfilePage.vue"
export default component.exports